//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import LazyHydrate from 'vue-lazy-hydration'
import CopyrightContainer from '~/components/copyrightContainer'
import VueToastMixin from '~/mixins/plugins/vue-toastification'
import layout from '~/mixins/layout'

export default {
  name: 'AccountLayout',
  components: {
    CopyrightContainer,
    InfoBar: () => import('~/components/Header/InfoBar'),
    HeaderContainer: () => import('~/components/HeaderContainer'),
    LazyHydrate
  },
  mixins: [VueToastMixin, layout],
  computed: {
    ...mapState({
      loadCounters: 'useCounters'
    }),
    ...mapGetters({
      currentLanguage: 'lang/currentLanguage',
      locale: 'lang/locale'
    })
  }
}
